import { IResourceComponentsProps } from '@refinedev/core';
import { AntdInferencer } from '@refinedev/inferencer/antd';

export const EarnNetworkShow: React.FC<IResourceComponentsProps> = () => {
  return <AntdInferencer />;
};
